import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { Dp10FetchAddressService } from '../../services/raintree/Transmission/dp1.0-fetch-address.service';
import { response } from 'express';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { map, Observable, startWith } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TitlecasePipe } from '../../custom-pipe/titlecase/titlecase.pipe';

@Component({
  selector: 'app-dp1.0-assign-popup',
  standalone: true,
  imports: [
    FormsModule,
    MatAutocompleteModule,
    MatInputModule,
    ReactiveFormsModule,
    CommonModule,
    TitlecasePipe
  ],
  templateUrl: './dp1.0-assign-popup.component.html',
  styleUrl: './dp1.0-assign-popup.component.scss'
})
export class Dp10AssignPopupComponent implements OnInit {

  isSelectedState: boolean = false;
  stateLists: any[] = [];
  filteredOptions!: Observable<any[]>;
  isLoading: boolean = false;
  selectedState = new FormControl('');
  stateDetails!: FormGroup;
  payload: any = [];
  districtLists: any[] = [];
  municipalityLists: any[] = []
  isLoadingDistrict: boolean = false;
  districtNameDisabled: boolean = true;
  municipalityNameDisabled: boolean = true;
  filteredOptionsD!: Observable<any[]>;
  filteredOptionsM!: Observable<any[]>;


  constructor(
    private fb: FormBuilder,
    private fetch_dp_1_0_data: Dp10FetchAddressService,
    private toaster: ToastrService,
    @Inject(MAT_DIALOG_DATA) public rowData: any,
    private dialogRef: MatDialogRef<Dp10AssignPopupComponent>
  ) { }



  ngOnInit(): void {
    console.log(this.rowData, 'rowData')
    console.log(this.rowData.userDetails.district, 'dist');

    this.stateDetails = this.fb.group({
      stateName: ['', Validators.required],
      districtName: ['', Validators.required],
      municipalityName: ['', Validators.required],
    });

    if (this.rowData.userDetails.state !== null) {
      if (this.rowData.userDetails.district !== null) {
        this.municipalityNameDisabled = false;
      }
      this.stateDetails.get('stateName')?.setValue(this.rowData.userDetails.state);
      //this.stateDetails.get('stateName')?.disable();
      this.onStateSelected(this.rowData.userDetails.state);
    }

    if (this.rowData.userDetails.district !== null) {
      if (this.rowData.userDetails.state !== null) {
        this.municipalityNameDisabled = false;
      }
      this.stateDetails.get('districtName')?.setValue(this.rowData.userDetails.district);
      //this.stateDetails.get('districtName')?.disable();
      this.onDistrictSelected(this.rowData.userDetails.district);
    }

    this.filteredOptions = this.stateDetails.controls['stateName'].valueChanges.pipe(
      startWith(""),
      map(val => this._filterState(val))
    );
    this.filteredOptionsD = this.stateDetails.controls['districtName'].valueChanges.pipe(
      startWith(""),
      map(val => this._filterDistrict(val))
    );
    this.filteredOptionsM = this.stateDetails.controls['municipalityName'].valueChanges.pipe(
      startWith(""),
      map(val => this._filterMunicipality(val))
    );

    this.fetchState();
  }

  _filterState(val: string) {
    const filterValue = val.toLowerCase();

    return this.stateLists.filter(option => option.state_name.toLowerCase().includes(filterValue));
  }
  _filterDistrict(val: string) {
    const filterValue = val?.toLowerCase();

    return this.districtLists.filter(option => option.district_name.toLowerCase().includes(filterValue));
  }
  _filterMunicipality(val: string) {
    const filterValue = val?.toLowerCase();
    return this.municipalityLists.filter(option => option.municipality_name?.toLowerCase().includes(filterValue));
  }

  fetchState() {
    this.isLoading = true;

    this.fetch_dp_1_0_data.fetchStateDp10({ uiCountry: this.rowData.userCountry }).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (!response.error) {
          this.stateLists = response.data || [];
        }
      },
      error: () => {
        this.isLoading = false;
        this.toaster.error('Error fetching states');
      },
    });
  }

  onStateSelected(state: string) {

    if (!state) return;
    if (this.rowData.userDetails.state === null) {
      this.stateDetails.patchValue({ districtName: '', municipalityName: '' });
    }
    console.log('Selected State:', state);
    this.districtLists = [];
    this.municipalityLists = [];
    // if (this.rowData.userDetails.state === null || this.rowData.userDetails.district === null) {
    //   console.log('we came here');
    //   this.stateDetails.get('districtName')?.reset();
    //   this.stateDetails.get('municipalityName')?.reset();
    //   this.stateDetails.get('districtName')?.enable();
    //   this.stateDetails.get('municipalityName')?.disable();
    // }
    this.stateDetails.get('districtName')?.reset();
    this.stateDetails.get('municipalityName')?.reset();
    this.stateDetails.get('districtName')?.enable();
    //this.stateDetails.get('municipalityName')?.disable();
    this.isLoading = true;

    this.fetch_dp_1_0_data.fetchStateDp10({ uiCountry: this.rowData.userCountry, state: state }).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (!response.error) {
          this.districtLists = response.data;
          this.districtNameDisabled = false;
        }
      },
      error: () => {
        this.isLoading = false;
        this.toaster.error('Error fetching districts');
      },
    });
  }

  onDistrictSelected(district: string) {

    if (!district) return;

    const state = this.stateDetails.get('stateName')?.value;
    this.stateDetails.patchValue({ municipalityName: '' });
    console.log('Selected District:', district);
    this.municipalityLists = [];
    this.stateDetails.get('municipalityName')?.reset();
    this.stateDetails.get('municipalityName')?.enable();

    this.isLoading = true;

    this.fetch_dp_1_0_data.fetchStateDp10({ uiCountry: this.rowData.userCountry, state: state, district: district }).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (!response.error) {
          this.municipalityLists = response.data;
          this.municipalityNameDisabled = false;
        }
      },
      error: () => {
        this.isLoading = false;
        this.toaster.error('Error fetching municipalities');
      },
    });
  }
  onMunicipalitySelected(municipality: any) {
    console.log('Selected Municipality:', municipality);

    if (!municipality) return;
    console.log('Selected Municipality:', municipality);

    this.stateDetails.patchValue({ municipalityName: municipality });
  }

  getFormValue(controlName: string): any {
    return this.stateDetails.get(controlName)?.value;
  }

  onSubmit() {

    if (this.stateDetails.invalid) {
      this.toaster.error('Please complete the form before submitting');
      return;
    }

    const bodyObj = {
      state: this.getFormValue('stateName'),
      district: this.getFormValue('districtName'),
      municipality: this.getFormValue('municipalityName'),
      userCountry: this.rowData.userCountry
    }

    this.isLoading = true;

    this.fetch_dp_1_0_data.sendDp10Data(this.rowData.userDetails.memKey, bodyObj).subscribe({
      next: () => {
        this.isLoading = false;
        this.toaster.success('Data submitted successfully');
        this.dialogRef.close(1); // Close the dialog on success
      },
      error: () => {
        this.isLoading = false;
        this.toaster.error('Failed to submit data');
      },
    });
  }

  onCloseDialog(){
    this.dialogRef.close(0);
  }

}